Namespace 'Monitoring.Views.SocialContents.Filters'

class Monitoring.Views.SocialContents.Filters.PostChannelsFilterView extends Backbone.View

  template: JST["backbone/templates/monitoring/filters/vue/common_template"]

  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery
    selectedProvider = @options.selectedProvider
    @sortedAvailableChannels = @options.sortedAvailableChannelsByProvider[selectedProvider]

    @vueChannelsFilter = new VueInBackbone.VueComponent(
      'channels-filter',
      {
        searchQuery: @searchQuery.toJSON(),
        texts: {
          title: I18n.t('monitoring.publications_session.channel'),
          placeholder: I18n.t('monitoring.publications_session.new_session.search_or_select_channels'),
          selectAll: I18n.t('monitoring.publications_session.new_session.select_all_channels')
        },
        channels: @sortedAvailableChannels,
        selectedProvider: selectedProvider
      }
    )

  render: ->
    @$el.html(@template)
    @$el.find('.filters-vue-common-template').append(@vueChannelsFilter.el)
    @vueChannelsFilter.render()
    @vueChannelsFilter.on('apply', @applyFilter)

    @

  applyFilter: (selectedChannelIds) =>
    @searchQuery.resetChannels()
    _.each(selectedChannelIds, (channelId) =>
      channel = _.find(@sortedAvailableChannels, (channel) -> channel.uid == channelId)
      @searchQuery.addChannel(channel)
    )

    @eventAggregator.trigger('searchQueryChanged', @searchQuery)

  destroy: ->
    @vueChannelsFilter.remove()
    @remove()
